module.exports = __webpack_public_path__ + "static/media/Darchviz 01.4ba74610.jpg";